import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSupplierOrder, updateSupplierOrder } from '../actions/SupplierOrderActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import SupplierOrderForm from '../components/SupplierOrderForm';

import Configuration from '../Config';
import { getSuppliers } from '../../suppliers/actions/SupplierActions';
import { getStockAccounts } from '../../stockAccount/actions/StockAccountActions';

const validation = Configuration.Validations.editSupplier;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditSupplierOrder extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    componentDidMount() {
        this.props.dispatch(getSupplierOrder(this.id));
        this.props.dispatch(getSuppliers());
        this.props.dispatch(getStockAccounts());
    }

    handleSave = (values) => {
        this.props.dispatch(updateSupplierOrder(this.props.supplierOrder.id, values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/supplier-orders">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista comenzi furnizori
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16}>
                        <Link to={`/supplier-orders/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Comanda Furnizor - <strong>{this.props.supplierOrder.nirNumber}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <SupplierOrderForm 
                            isEdit={true}
                            suppliers={this.props.suppliers}
                            stockAccounts={this.props.stockAccounts}
                            initialValues={this.props.supplierOrder}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        suppliers: state.suppliers.data,
        stockAccounts: state.stockAccounts.data,
        errors: state.supplierOrders.errors.type === 'validation' ? mapValidationErrors(state.supplierOrders.errors.fields): [],
        supplierOrder: state.supplierOrders.current
    }
}

export default connect(mapStateToProps)(EditSupplierOrder);